module.exports = __webpack_public_path__ + "static/media/insu-allianz.5c6e69d5.svg";